module.exports = __webpack_public_path__ + "img/durocher_svg_V10.3b5cef5e.svg";